export enum InterventionSetIdEnum {
    CoxBazar = 1,
    BhasanChar = 2,
} 